import { useEffect, useState } from 'react'
import { Box, Button, Card, Divider, Tab, useMediaQuery } from '@mui/material'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ContentTitle } from '~/components/ContentTitle'
import { TabPanel, TabContext } from '@mui/lab'
import { TabListWithPadding } from './styles'
import { BasicData } from './BasicData'
import { EPersonType, useContractGetQuery, useCustomerGetQuery, ContractModel } from '~/graphql/types'
import { Address } from './Address'
import { Documents } from './Documents'
import { ModalPendencies } from './ModalPendencies'
import { useToggle } from '~/hooks'
import { FieldsType, StepPendency } from './types'
import { Representatives } from './Representatives'
import { ContractHeaderInformations } from '~/components'
import { theme } from '~/utils'
import { FullPageLoader } from '~/components/FullPageLoader'
import { toast } from 'react-toastify'
import { IconChevronLeft } from '@tabler/icons-react'
import { useContract } from '~/contexts'

export const ContractResolvePendencies: React.FC = () => {
  const { isTrue, toggle, setIsTrue } = useToggle(false)
  const [stepPendencyValue, setStepPendencyValue] = useState<StepPendency>('basicData')
  const [contract, setContract] = useState<ContractModel | null>(null)
  const [representativeIndex, setRepresentativeIndex] = useState(0)
  const [modalType, setModalType] = useState<'approve' | 'refuse'>('approve')
  const [fields, setFields] = useState<FieldsType>({})
  const [hasShownAuditInfo, setHasShownAuditInfo] = useState(false)
  const isLowerXs = useMediaQuery('(max-width:500px)')
  const isLowerToTabs = useMediaQuery('(max-width:693px)')
  const isLowerSm = useMediaQuery(theme.breakpoints.down('sm'))
  const { contractId } = useParams()
  const navigate = useNavigate()
  const { setContract: setContractContext } = useContract()

  const { refetch, loading: contractIsLoading } = useContractGetQuery({
    variables: {
      id: contractId || '',
    },
    onCompleted: (currentData) => {
      setContract(currentData.contractGet as ContractModel)
      setContractContext(currentData.contractGet as ContractModel)
      if (currentData.contractGet && currentData.contractGet.isFormalizedByPartner === false) {
        if (!hasShownAuditInfo) {
          toast.info('Esse contrato não precisa passar por auditoria')
          setHasShownAuditInfo(true)
        }
        navigate(`/app/contracts/${contractId}`)
      }
    },
    onError: () => toast.error('Ocorreu um erro ao carregar este contrato.')
  })

  const { refetch: refetchCustomer } = useCustomerGetQuery({
    variables: {
      id: contract?.customerId || ''
    },
    skip: !contract?.customerId
  })

  useEffect(() => {
    if (!contract?._id) {
      refetch()
    }
  }, [])

  useEffect(() => {
    if (contract && contract.isFormalizedByPartner === false && contractId) {
      if (!hasShownAuditInfo) {
        toast.info('Esse contrato não precisa passar por auditoria')
        setHasShownAuditInfo(true)
      }
      navigate(`/app/contracts/${contractId}`)
    }
  }, [contract, contractId])

  const handleChange = (event: React.SyntheticEvent, newValue: StepPendency) => {
    setStepPendencyValue(newValue)
  }

  const onRefuse = () => {
    setModalType('refuse')
    toggle()

  }
  const onApprove = () => {
    setModalType('approve')
    toggle()
  }

  if (contractIsLoading) return <FullPageLoader />

  return (
    <div>
      <Card sx={{ background: 'white', padding: isLowerSm ? '1rem' : '0 1rem', borderRadius: '1rem', }}>
        {isLowerSm ? (
          <>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexFlow: isLowerXs ? 'column' : 'row', gap: isLowerXs ? '1rem' : '0' }}>
              <Link to='/app/contracts'>
                <Button size='small' sx={{ margin: '0' }} color='secondary'>
                  <IconChevronLeft />
                </Button>
              </Link>
              {contract && <ContractHeaderInformations isDisabledSalesFunnelDropdown={true} />}
            </Box>
            <Divider sx={{ marginTop: 4, marginBottom: 4 }} />
            <ContentTitle
              style={{ padding: '0px 0px 24px 0px' }}
              title='Detalhes do contrato'
              description='Acompanhe e dê continuidade a proposta'
              breadcrumbLinks={{
                currentLink: contract?._id ?? '',
                links: [{ href: '/app/', label: 'Vendas' }, { href: '/app/contracts', label: 'Contratos' }]
              }}
            />
          </>
        )
          : (
            <>
              <ContentTitle
                title='Detalhes do contrato'
                description='Acompanhe e dê continuidade a proposta'
                breadcrumbLinks={{
                  currentLink: contract?._id ?? '',
                  links: [{ href: '/app/', label: 'Vendas' }, { href: '/app/contracts', label: 'Contratos' }]
                }}
                rightContent={
                  <>
                    {contract ? <ContractHeaderInformations isDisabledSalesFunnelDropdown={true} /> : undefined}
                  </>
                }
              />
            </>
          )}

        <Box sx={{ typography: 'body1', padding: '1rem 0' }}>
          <TabContext value={stepPendencyValue}>
            <Box sx={{ borderBottom: 1, borderTop: 1, borderColor: 'divider', maxWidth: 'calc(100vw - 97px)' }}>
              <TabListWithPadding
                // variant='scrollable'
                scrollButtons='auto'
                // allowScrollButtonsMobile
                onChange={handleChange}
                aria-label='Etapas da proposta'
              >
                <Tab sx={{ margin: isLowerToTabs ? '0' : '.6rem 0' }} label='Dados básicos' value='basicData' />
                <Tab sx={{ margin: isLowerToTabs ? '0' : '.6rem 0' }} label='Endereço' value='address' />
                <Tab sx={{ margin: isLowerToTabs ? '0' : '.6rem 0' }} label='Documentos' value='documents' />
                {contract?.customerRef.personType === EPersonType.pj &&
                  <Tab sx={{ margin: isLowerToTabs ? '0' : '.6rem 0' }} label='Representantes' value='representativies' />
                }
              </TabListWithPadding>
            </Box>
            <TabPanel sx={{ padding: '2rem 0' }} value='basicData'>
              <BasicData setFields={setFields} modalType={modalType} onRefuse={onRefuse} onApprove={onApprove} contract={contract} />
            </TabPanel>
            <TabPanel sx={{ padding: '2rem 0' }} value='address'>
              <Address setFields={setFields} modalType={modalType} onRefuse={onRefuse} onApprove={onApprove} contract={contract} />
            </TabPanel>
            <TabPanel sx={{ padding: '2rem 0' }} value='documents'>
              <Documents setFields={setFields} modalType={modalType} onRefuse={onRefuse} onApprove={onApprove} contract={contract} setContract={setContract} />
            </TabPanel>
            {contract?.customerRef.personType === EPersonType.pj &&
              (
                <TabPanel sx={{ padding: '2rem 0' }} value='representativies'>
                  <Representatives
                    representativeIndex={representativeIndex}
                    setRepresentativeIndex={setRepresentativeIndex}
                    setFields={setFields}
                    modalType={modalType}
                    onRefuse={onRefuse}
                    onApprove={onApprove}
                    contract={contract}
                    onRefetchCustomer={refetchCustomer}
                  />
                </TabPanel>
              )
            }

          </TabContext>
        </Box>
      </Card>
      <ModalPendencies
        representativeIndex={representativeIndex}
        stepPendencyValue={stepPendencyValue}
        setFields={setFields}
        contract={contract}
        setContract={setContract}
        fields={fields}
        type={modalType}
        onClose={() => toggle()}
        isVisible={isTrue}
        setIsVisible={setIsTrue}
        onSuccess={() => {
          refetch()
          refetchCustomer()
        }}
      />
    </div>
  )
}
